import { FleetType, Site } from '@jucy-ui/common';

export const getSiteSettings = ({ branch, fleetType }: { branch: Site; fleetType: FleetType }) =>
    branch.siteSettings.find((siteSetting) => siteSetting.fleetTypeId === fleetType.id);
